export default function MarketPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Market Prices</h1>
      <p className="text-muted-foreground">Market price charts and forecasting will be displayed here.</p>
    </div>
  );
}
